export default "__VITE_ASSET__B402BuuQ__"